import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";

interface CustomDialogProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  children: React.ReactNode;
  actions?: React.ReactNode;
  hideClose?: boolean;
}

export const CustomDialog: React.FC<CustomDialogProps> = ({
  open,
  onClose,
  title,
  maxWidth = "md",
  children,
  actions,
  hideClose = false,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth>
      {/* Header */}
      {title && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          px={2}
          py={1.5}
          borderBottom="1px solid #e0e0e0"
        >
          <Typography variant="h6" fontWeight={600}>
            {title}
          </Typography>

          {!hideClose && (
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          )}
        </Box>
      )}

      {/* Content */}
      <DialogContent sx={{ p: 2 }}>{children}</DialogContent>

      {/* Actions */}
      {actions && (
        <DialogActions sx={{ px: 2, pb: 2 }}>
          {actions}
        </DialogActions>
      )}
    </Dialog>
  );
};
